module.exports = "/packs/images/svg/facilities/badminton_court~bffd11f41ac6b38fe1e52d577e43592c.svg";